import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { REDESIGN_COLORS } from '../../constants';

const useStyles = makeStyles(() => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '999px',
        color: REDESIGN_COLORS.link,
        fontWeight: 800,
        textTransform: 'uppercase',
        textAlign: 'left',
    },
    section: {
        padding: '8px 13px',
        border: `1px solid ${REDESIGN_COLORS.primaryBorderSoft}`,
        background: REDESIGN_COLORS.mist,
        fontSize: '0.76rem',
        letterSpacing: '0.09em',
    },
    card: {
        padding: '6px 10px',
        background: REDESIGN_COLORS.white,
        fontSize: '0.68rem',
        letterSpacing: '0.07em',
    },
    dot: {
        flexShrink: 0,
        borderRadius: '50%',
        background: REDESIGN_COLORS.accent,
    },
    dotSection: {
        width: '8px',
        height: '8px',
    },
    dotCard: {
        width: '7px',
        height: '7px',
    },
}));

/**
 * The pill label that sits above every heading in the redesign, and again inside
 * the feature/context cards. `section` is the bordered mint pill, `card` the
 * smaller white one.
 */
const SectionEyebrow = ({ variant = 'section', className, children }) => {
    const classes = useStyles();
    const isCard = variant === 'card';

    return (
        <span className={[classes.root, isCard ? classes.card : classes.section, className].filter(Boolean).join(' ')}>
            <span aria-hidden="true" className={`${classes.dot} ${isCard ? classes.dotCard : classes.dotSection}`} />
            {children}
        </span>
    );
};

export default SectionEyebrow;
